import { IItemTagState } from '@/store/item-tag';
import { IItemTagMutations } from './mutations.types';
import { ITagData } from '@/models';

export const mutations: IItemTagMutations = {
  SET_ITEM_TAGS(state: IItemTagState, payload: ITagData[]): void {
    state.tags = payload;
  },

  ADD_ITEM_TAG(state: IItemTagState, payload: ITagData): void {
    state.tags.push(payload);
  },

  UPDATE_ITEM_TAG(state: IItemTagState, payload: ITagData): void {
    const index = state.tags.findIndex(
      (tag: ITagData) => tag.id === payload.id
    );

    state.tags.splice(index, 1, payload);
  },

  REMOVE_ITEM_TAG(state: IItemTagState, payload: number): void {
    const index = state.tags.findIndex((tag: ITagData) => tag.id === payload);

    state.tags.splice(index, 1);
  },

  SET_LAST_PROMISE(state: IItemTagState, payload: Promise<any>): void {
    state.lastPromise = payload;
  }
};
